export default __webpack_public_path__ + "static/Metal_Double_Door-96f124cbe1a3bc1e96fbcace17ef3371.png";